angular.module("app").directive("circlePercentageWithLogo", function () {
  function link(scope) {
    scope.radius = 80;
    const circumference = scope.radius * 2 * Math.PI;

    scope.value = Math.round(scope.value);
    scope.strokeDasharrayValue = `${circumference} ${circumference}`;
    scope.strokeDashoffsetValue =
      circumference - (scope.value / 100) * circumference;
  }
  return {
    restrict: "E",
    templateUrl: "app/directives/circlePercentageWithLogo/circlePercentageWithLogo.html",
    link: link,
    scope: {
      value: "=",
      color: "=",
      logo: "=",
    },
  };
});
